import { Checkbox, FormControlLabel, Stack } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { SearchButton } from "share-components/mui-wrap/button/search-button";
import { PageContentContainer } from "share-components/templates/page/page-content-container";
import { PageFilterContainer } from "share-components/templates/page/page-filter-container";
import { MaterialGroupSelectionConnected } from "../shared-components";
import { MaterialInventoryTable } from "./material-inventory-table";

export const MaterialInventoryList = observer(() => {
  const {
    materialInventoryManagement: {
      materialInventoryStore: {
        pagination,
        getMaterialsInventory,
        queryParams: {
          code,
          name,
          type,
          barcode,
          showZeroQuantity,
          setProp: setQueryParamProp,
        },
      },
    },
  } = useStores();

  const onSearch = useCallback(async () => {
    pagination.setProp("pageIndex", 0);
    await getMaterialsInventory();
  }, [getMaterialsInventory, pagination]);

  const showZeroQuantityHandler = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      setQueryParamProp("showZeroQuantity", checked);
      getMaterialsInventory();
    },
    [getMaterialsInventory, setQueryParamProp],
  );

  return (
    <>
      <PageFilterContainer direction={"row"} alignItems={"center"}>
        <MaterialGroupSelectionConnected
          codeSelected={code}
          typeSelected={type}
          nameSelected={name}
          barcodeSelected={barcode}
          setSelectionProp={setQueryParamProp}
        ></MaterialGroupSelectionConnected>

        <SearchButton asyncAction={onSearch}></SearchButton>
      </PageFilterContainer>
      <Stack
        direction={"row"}
        justifyContent={"right"}
        sx={{ marginTop: "10px" }}
        spacing={1}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={showZeroQuantity}
              onChange={showZeroQuantityHandler}
            />
          }
          label="Gồm tồn bằng 0"
        />
      </Stack>
      <PageContentContainer sx={{ marginTop: "10px" }}>
        <MaterialInventoryTable></MaterialInventoryTable>
      </PageContentContainer>
    </>
  );
});
